// extracted by mini-css-extract-plugin
export var closeButton = "_hm-2";
export var closeButtonIcon = "_hm-3";
export var lightboxContent = "_hm-1";
export var lightboxOverlay = "_hm-0";